import { formatPhone } from 'src/utils/formatInputs';
import { IError } from '../BusinessInfo';
import Input from 'src/components/forms/input';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useLocalization } from 'src/utils/useLocalization';
import { validateMI } from '../../utils';
import React, { useState } from 'react';

interface IProps {
    handlerEdit: Function;
    object: {
        firstName: string;
        mi: string;
        lastName: string;
        telephone: string;
    };
    errors: {
        firstName: IError;
        mi: IError;
        lastName: IError;
        telephone: IError;
    };
    disabled: boolean;
}

const ResponsibleComponent = ({ handlerEdit, object, errors }: IProps) => {
    const { businessComercial } = useLocalization();
    const { markCreditFormTouched } = useCreditForm();
    const [oldPhone, setOldPhone] = useState<string>('');
    const propertyName = 'responsible';
    const validatePhone = (e: any) => {
        let aux: string = e.target.value
            .split('(')
            .join()
            .split(')')
            .join()
            .split('-')
            .join();
        aux = aux.replaceAll(',', '').replaceAll(' ', '');
        if (/^[0-9]*$/.test(aux)) {
            let newValue = '';
            if (e.target.value.length > oldPhone.length) {
                newValue = formatPhone(e.target.value);
            } else {
                newValue = e.target.value;
            }
            handlerEdit(
                {
                    name: e.target.name,
                    value: newValue,
                },
                propertyName,
            );
            setOldPhone(e.target.value);
        }
        markCreditFormTouched();
    };
    return (
        <div className={'business-responsible u-mt-large'}>
            <span className='c-form-section__header-content'>
                <span className='c-form-section__title  js-form-section__trigger'>
                    <span
                        className='c-form-section__title-text form-section__title-font'
                        role='heading'
                    >
                        {businessComercial.RESPONSIBLE_TITLE}
                    </span>
                </span>
            </span>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/3 u-1/1@xs'>
                        <Input
                            labelName={businessComercial.RESPONSIBLE_NAME}
                            type={'text'}
                            name={'firstName'}
                            handlerChange={(e: any) => {
                                handlerEdit(e.target, propertyName);
                            }}
                            value={object.firstName}
                            maxlength={20}
                            asTouched={errors.firstName.error}
                            asErrors={errors.firstName.msg}
                        />
                    </div>
                    <div className='o-layout__item  u-1/3 u-1/1@xs'>
                        <Input
                            labelName={businessComercial.RESPONSIBLE_MI}
                            type={'text'}
                            name={'mi'}
                            handlerChange={(e: any) => {
                                markCreditFormTouched();
                                const { value } = e.target;
                                if (validateMI(value) || value === '')
                                    handlerEdit(e.target, propertyName);
                            }}
                            value={object.mi}
                            maxlength={1}
                            asTouched={errors.mi.error}
                            asErrors={errors.mi.msg}
                        />
                    </div>
                    <div className='o-layout__item  u-1/3  u-1/1@xs'>
                        <Input
                            labelName={businessComercial.RESPONSIBLE_LASTNAME}
                            type={'text'}
                            name={'lastName'}
                            handlerChange={(e: any) => {
                                handlerEdit(e.target, propertyName);
                            }}
                            value={object.lastName}
                            maxlength={20}
                            asTouched={errors.lastName.error}
                            asErrors={errors.lastName.msg}
                        />
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item  u-1/2 u-1/1@xs'>
                        <Input
                            labelName={businessComercial.RESPONSIBLE_TELEPHONE}
                            type={'text'}
                            name={'telephone'}
                            handlerChange={validatePhone}
                            value={object.telephone}
                            maxlength={14}
                            asTouched={errors.telephone.error}
                            asErrors={errors.telephone.msg}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResponsibleComponent;
